module.exports = __webpack_public_path__ + "img/logo.28694542.svg";